import React, { useEffect, useState } from 'react';
import { useLang } from '../context/LanguageContext';
import './Hero.css';

function SplitText({ text, className }) {
  return (
    <span className={className} aria-label={text}>
      {text.split('').map((char, i) => (
        <span
          key={i}
          className="hero__char"
          style={{ animationDelay: `${0.6 + i * 0.045}s` }}
          aria-hidden="true"
        >
          {char === ' ' ? ' ' : char}
        </span>
      ))}
    </span>
  );
}

export default function Hero() {
  const { t } = useLang();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setReady(true), 80);
    return () => clearTimeout(id);
  }, []);

  return (
    <section id="home" className={`hero${ready ? ' hero--ready' : ''}`}>
      <div className="hero__bg" />

      <div className="hero__content">
        <h1 className="hero__name">
          <SplitText text={t.hero.name} />
        </h1>
        <div className="hero__rule" />
        <a href="#gallery" className="hero__cta">{t.hero.cta}</a>
      </div>

      <div className="hero__scroll-hint" />
    </section>
  );
}
